import { useLazyGetAccessSignedUrlQuery } from "@/services";
import { useSnackbar } from "@/hooks";

const useDownloadFile = () => {
  const [getAccessSignedUrl, { isLoading }] = useLazyGetAccessSignedUrlQuery();
  const { show } = useSnackbar();

  const downloadFile = async ({ name, key }: { name: string; key: string }) => {
    try {
  //
      const { signedUrl } = await getAccessSignedUrl({
        fileName: key,
      }).unwrap();

      const response = await fetch(signedUrl);

      if (!response.ok) {
        throw new Error("Download failed!");
      }

      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
      show("Successfully downloaded", `${name} downloaded successfully!`, "success");
    } catch (error) {
      if (error instanceof Error) {
        show("Failed to download file", error.message, "error");
      }
    }
  };

  return { downloadFile, isLoading };
};

export default useDownloadFile;
